import types from './types';
import actions from './actions';
import { ValueOf } from 'sl-api-connector/types';

const chargeBackIssueTypes = (state = [], action: ReturnType<ValueOf<typeof actions>>) => {
  switch (action.type) {
    case types.RECEIVE_ALL_CHARGEBACK_ISSUE_TYPES:
      return Object.assign([], action.chargeBackIssueTypes);
    case types.CLEAR_ALL_CHARGEBACK_ISSUE_TYPES:
      return [];
    default:
      return state;
  }
};

export default chargeBackIssueTypes;
